import { MaterialDataPage } from "./materialdata/MaterialData";

export const HandelsappPage = MaterialDataPage;
